import React, { ReactNode } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import DropdownWithCheckboxSelection from 'common/SelectAdvancedWithGrouping/DropdownWithCheckboxSelection';

const Items = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--line-gray);
  max-height: 200px;
  overflow-y: auto;
  padding: 10px 20px;
`;

const ItemsTitle = styled.span`
  font-family: var(--font-bold);
  margin-bottom: 15px;
`;

const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;

  &.padded {
    padding-left: 24px;
  }
`;

const ColorDot = styled.span`
  color: ${(props) => props.color};
  margin-right: 8px;
`;

interface PropsList {
  title: string;
  items: any[];
  icon?: ReactNode;
  showGroupingDropdown?: boolean;
  onSelect: any;
}

const DropdownItemsListRow = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SelectAdvancedWithGroupingDropdownItemsList = ({
  title,
  items,
  icon,
  onSelect,
  showGroupingDropdown = false,
}: PropsList) => (
  <Items>
    <ItemsTitle>{title}</ItemsTitle>
    <ItemsList>
      {items.map((item) => (
        <Item key={item.value} className={classNames({ padded: !icon })} onClick={() => onSelect(item)}>
          {icon}
          <DropdownItemsListRow>
            <div>
              {item?.color && <ColorDot color={item.color}>●</ColorDot>}
              <span>{item.label}</span>
            </div>
            {showGroupingDropdown && <DropdownWithCheckboxSelection apartmentTypes={item.options} />}
          </DropdownItemsListRow>
        </Item>
      ))}
    </ItemsList>
  </Items>
);

export default SelectAdvancedWithGroupingDropdownItemsList;
